import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Alertbox } from '@olxbr/ds-web'

const Container = styled.div`
  margin-bottom: 32px;
  margin-top: 8px;
`

export const VerifiedAlertbox = ({ children, ...props }) => {
  return (
    <Container>
      <Alertbox variant="information" {...props}>
        {children}
      </Alertbox>
    </Container>
  )
}

VerifiedAlertbox.propTypes = {
  children: PropTypes.node.isRequired,
}
